export class AuditLogStateSnapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "previousState",
            "baseName": "previousState",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "newState",
            "baseName": "newState",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "redactedFields",
            "baseName": "redactedFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "truncated",
            "baseName": "truncated",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogStateSnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
